/*
  NattyPLUS PDP Buy Box Idea6 — Intelligems group-1 winner restyle
  Activated by class np-ab-idea6 on .product (theme setting
  "Enable buy box Idea6 restyle") or on html/body (Intelligems A/B).
  Injects CSS, densifies cards, shared ATC footer, plus-lines on 90-day.
  Formerly assets/cursor-js.js (handle-gated); renamed + customizer-gated.

  v2.1: the shine sweeps are actually VISIBLE now, matching the popup exactly.
        The shared ATC's sweep sat at z-index:-1 inside an isolated button, so
        it painted behind the button's own opaque gradient and never showed;
        and the 30-day badge's sweep was switched off in np-pdp-buy-box-v2.css.
        Both restored. Fill, type and metrics deliberately UNCHANGED — the PDP
        ATC keeps the product gradient (it sits on the dark page, not on a
        gold card like the popup's).
  v2.0: shared ATC matches the quick-buy popup's Add To Cart (Geist 700 Title
        Case, 8px radius) and carries the same looping shine sweep.
  v1.9: OTP SAVE badge also visible when One-time card is collapsed.
  v1.8: show gold SAVE badge on active One-time Purchase card (was force-hidden).
  v1.7: selected-card / badge / ATC colours come from the product's existing
  buy-box v2 palette (--np-bb-card-grad / --np-bb-cta-grad / --np-bb-accent
  via data-np-palette). Do NOT hardcode the Test Booster gold over other PDPs.
*/
(function () {
  'use strict';

  var STYLE_ID = 'np-ab-idea6-css';
  var FLAG = 'npAbIdea6';
  var LOG = '[np-ab-idea6]';
  var VER = '2.1';
  // Fallback only when no palette vars are set (matches testosterone default).
  var GOLD = 'linear-gradient(90deg,#F6D365 -10%,#D4A94F 50%,#A6782E 110%)';
  var FILL = 'var(--np-bb-card-grad,' + GOLD + ')';
  var CTA = 'var(--np-bb-cta-grad,var(--np-bb-card-grad,' + GOLD + '))';
  var RING = 'var(--np-bb-accent,#D4A850)';
  var WAIT_MS = 15000;
  var ROOT_SELECTORS = [
    '.product.np-ab-idea6',
    'html.np-ab-idea6',
    'body.np-ab-idea6'
  ];

  var RERUN = !!(window[FLAG] && window[FLAG].applied);
  if (!window[FLAG]) window[FLAG] = { applied: false };

  function warn(msg, extra) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn(LOG, msg, extra || '');
    }
  }

  function inScopePage() {
    try {
      for (var i = 0; i < ROOT_SELECTORS.length; i++) {
        if (document.querySelector(ROOT_SELECTORS[i])) return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function findWidget() {
    var productRoot = document.querySelector('.product.np-ab-idea6');
    if (productRoot) {
      return (
        productRoot.querySelector('.np-sub-widget[data-np-widget], .np-sub-widget') ||
        null
      );
    }
    if (
      document.documentElement.classList.contains('np-ab-idea6') ||
      (document.body && document.body.classList.contains('np-ab-idea6'))
    ) {
      return document.querySelector('.np-sub-widget[data-np-widget], .np-sub-widget');
    }
    return null;
  }

  function beat(rests) {
    if (typeof rests === 'string') rests = [rests];
    var host = '.np-sub-widget.np-ab-idea6';
    var prefixes = [
      'html.np-ab-idea6.np-pdp-buy-box-v2 .product ' + host,
      'html.np-pdp-buy-box-v2 .product ' + host,
      'body.np-pdp-buy-box-v2 .product ' + host,
      '.product.np-pdp-buy-box-v2 ' + host,
      'html.np-ab-idea6 ' + host,
      host
    ];
    var sels = [];
    rests.forEach(function (rest) {
      prefixes.forEach(function (p) {
        sels.push(p + rest);
      });
    });
    return sels.join(',\n');
  }

  function cssText() {
    return [
      '/* np-ab-idea6 v' + VER + ' */',
      beat([
        ' .np-card-subtitle',
        ' .np-card-meta',
        ' .np-price-period',
        ' .np-price-note',
        ' .np-qty-stepper',
        ' .np-card-action',
        ' .np-card-foot',
        ' .np-v2-legacy-only',
        ' .np-v2-bloodwork-legacy',
        ' .np-radio svg'
      ]) + '{display:none!important}',

      /* OTP SAVE badge: show whenever savings exist (open + collapsed) */
      beat(' .np-card--one .np-badge[hidden]') + '{display:none!important}',
      beat(' .np-card--one .np-badge:not([hidden])') +
        '{display:inline-flex!important;background:' +
        FILL +
        '!important;background-image:' +
        FILL +
        '!important;color:#161616!important}',
      beat(' .np-card--one .np-badge:not([hidden]) .np-v2-only') +
        '{display:inline!important;background:transparent!important;background-image:none!important;color:#161616!important}',

      beat('') +
        '{padding:0!important;margin:0!important;border:0!important;border-radius:0!important;background:transparent!important;background-image:none!important;box-shadow:none!important;font-family:Geist,sans-serif}',
      beat(' .np-eyebrow') +
        '{font-family:"Geist Mono",ui-monospace,monospace!important;font-size:12px!important;font-weight:600!important;letter-spacing:.16em!important;color:#8A8A90!important;margin:0 0 14px!important;text-transform:uppercase}',
      beat(' .np-cards') + '{gap:14px!important}',

      beat(' .np-card') +
        '{background:#1E1E22!important;background-image:none!important;border:1.5px solid #5A5A66!important;color:#F4F4F5!important;padding:18px 18px 17px!important;border-radius:16px!important;box-shadow:none!important}',
      beat(' .np-card--one') + '{background:#101014!important;border-color:#5A5A66!important}',

      beat(' .np-card-head') +
        '{flex-direction:column!important;align-items:flex-start!important;gap:0!important;width:100%}',
      beat(' .np-card-head-main') +
        '{display:flex!important;align-items:center!important;gap:11px!important;width:100%}',
      beat(' .np-card-head-left') + '{min-width:0}',
      beat(' .np-card-title') +
        '{font-family:Archivo,sans-serif!important;font-style:normal!important;font-stretch:100%!important;font-variation-settings:"wdth" 100,"wght" 800!important;font-size:21px!important;font-weight:800!important;letter-spacing:-.01em!important;line-height:normal!important;text-transform:none!important;white-space:nowrap;margin:0!important;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}',
      beat(' .np-radio') +
        '{flex:none!important;box-sizing:content-box!important;width:20px!important;height:20px!important;min-width:20px!important;min-height:20px!important;max-width:20px!important;max-height:20px!important;padding:0!important;margin:0!important;border-radius:50%!important;border:2px solid #7A7A86!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;background:transparent!important;position:relative;overflow:hidden}',
      beat(' .np-radio::after') +
        '{content:"";box-sizing:content-box!important;display:block;flex:none;width:9px!important;height:9px!important;margin:0;padding:0;border:0;border-radius:50%;background:transparent}',
      beat(' .np-card.np-active .np-radio') + '{border-color:#161616!important}',
      beat(' .np-card.np-active .np-radio::after') + '{background:#161616}',
      beat(' .np-card--one.np-active .np-radio') + '{border-color:' + RING + '!important}',
      beat(' .np-card--one.np-active .np-radio::after') + '{background:' + RING + '}',

      beat(' .np-badge') +
        '{display:inline-flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center;align-self:flex-start!important;width:max-content!important;max-width:100%!important;flex:none!important;gap:5px;font-family:"Geist Mono",ui-monospace,monospace!important;font-size:10px!important;font-weight:600!important;letter-spacing:.06em!important;line-height:1.1!important;padding:5px 11px!important;border-radius:7px!important;border:none!important;margin:12px 0 0!important;white-space:nowrap;text-transform:uppercase;position:static!important;top:auto!important;right:auto!important;overflow:visible!important;isolation:auto!important}',
      beat(' .np-badge .np-v2-only') +
        '{display:inline!important;width:auto!important;padding:0!important;margin:0!important;background:transparent!important;background-image:none!important;color:inherit!important;border:0!important}',
      beat(' .np-badge > :not(.np-v2-only)') + '{display:none!important}',
      // Badge shine, same sweep as the quick-buy popup's 30-day badge
      // (np-subscription-widget `.np-card--gold .np-badge::before`). The
      // `.np-badge` rule above forces position:static / overflow:visible, which
      // would anchor the sweep to the CARD and leave it unclipped — so the gold
      // badge gets its containing block and clip back here. position:relative
      // with no offsets is layout-identical to static, and the badge holds
      // nothing but its own label, so the clip only ever bites the pseudo.
      // Gold card only, exactly as in the popup — the 90-day badge stays plain.
      beat(' .np-card--gold .np-badge') +
        '{position:relative!important;overflow:hidden!important;isolation:isolate!important}',
      beat(' .np-card--gold .np-badge::before') +
        '{content:"";display:block!important;position:absolute;inset:0;z-index:1;pointer-events:none;background:linear-gradient(100deg,transparent 30%,rgba(255,255,255,.55) 50%,transparent 70%);transform:translateX(-120%);animation:np-ab-shine 3.2s ease-in-out infinite}',
      beat([' .np-card-prices', ' .np-price-onetime-wrap']) +
        '{display:flex!important;flex-direction:row!important;align-items:baseline!important;gap:10px!important;width:auto!important;margin:15px 0 0!important;padding:0!important}',
      beat([' .np-price-now', ' .np-price-onetime', ' [data-card-price]', ' [data-onetime-display]']) +
        '{font-family:Geist,sans-serif!important;font-size:17px!important;font-weight:800!important;letter-spacing:-.02em!important;line-height:1.1!important}',
      beat([' .np-price-was', ' [data-card-was-price]']) +
        '{font-family:Geist,sans-serif!important;font-size:12.5px!important;font-weight:600!important;text-decoration:line-through!important;text-decoration-thickness:1.5px}',
      beat(' .np-v2-delivery') +
        '{font-family:"Geist Mono",ui-monospace,monospace!important;font-size:10px!important;font-weight:500!important;letter-spacing:.08em!important;margin:11px 0 0!important;text-transform:uppercase!important;white-space:nowrap}',

      beat(' .np-card--gold:not(.np-active)') +
        '{background:#1E1E22!important;background-image:none!important;border:1.5px solid #5A5A66!important;color:#F4F4F5!important}',
      beat([
        ' .np-card--gold:not(.np-active) .np-card-title',
        ' .np-card--gold:not(.np-active) .np-price-now',
        ' .np-card--gold:not(.np-active) [data-card-price]',
        ' .np-card--gold:not(.np-active) .np-v2-delivery'
      ]) + '{color:#F4F4F5!important}',
      beat([
        ' .np-card--gold:not(.np-active) .np-price-was',
        ' .np-card--gold:not(.np-active) [data-card-was-price]',
        ' .np-card--dark:not(.np-active) .np-price-was',
        ' .np-card--dark:not(.np-active) [data-card-was-price]'
      ]) + '{color:#6E6E6E!important}',
      beat([
        ' .np-card--gold:not(.np-active) .np-badge',
        ' .np-card--gold:not(.np-active) .np-badge.np-badge--popular',
        ' .np-card--dark:not(.np-active) .np-badge'
      ]) +
        '{background:' +
        FILL +
        '!important;background-image:' +
        FILL +
        '!important;color:#161616!important}',
      beat([
        ' .np-card--gold:not(.np-active) .np-badge .np-v2-only',
        ' .np-card--gold:not(.np-active) .np-badge__save',
        ' .np-card--dark:not(.np-active) .np-badge .np-v2-only',
        ' .np-card--dark:not(.np-active) .np-badge__save',
        ' .np-card--dark:not(.np-active) .np-badge-popular'
      ]) + '{background:transparent!important;background-image:none!important;color:#161616!important}',
      beat(' .np-card--gold:not(.np-active) .np-v2-delivery') + '{color:#8A8A90!important}',
      beat(' .np-card--dark:not(.np-active) .np-v2-delivery') + '{color:#8A8A90!important}',

      beat([' .np-card--gold.np-active', ' .np-card--dark.np-active']) +
        '{background:' + FILL + '!important;background-image:' + FILL + '!important;border:1px solid transparent!important;color:#161616!important}',
      beat([
        ' .np-card--gold.np-active .np-card-title',
        ' .np-card--dark.np-active .np-card-title',
        ' .np-card--gold.np-active .np-price-now',
        ' .np-card--dark.np-active .np-price-now',
        ' .np-card--gold.np-active [data-card-price]',
        ' .np-card--dark.np-active [data-card-price]',
        ' .np-card--gold.np-active .np-v2-delivery',
        ' .np-card--dark.np-active .np-v2-delivery',
        ' .np-card--gold.np-active .np-benefits li',
        ' .np-card--dark.np-active .np-benefits li',
        ' .np-card--dark.np-active .np-v2-gift-copy',
        ' .np-card--dark.np-active .np-v2-gift-sub',
        ' .np-card--dark.np-active .np-bloodwork-note',
        ' .np-card--dark.np-active .np-v2-bloodwork-copy'
      ]) + '{color:#161616!important}',
      beat([
        ' .np-card--gold.np-active .np-price-was',
        ' .np-card--dark.np-active .np-price-was',
        ' .np-card--gold.np-active [data-card-was-price]',
        ' .np-card--dark.np-active [data-card-was-price]'
      ]) + '{color:#161616!important;opacity:.85}',
      beat([' .np-card--gold.np-active .np-badge', ' .np-card--dark.np-active .np-badge']) +
        '{background:#161616!important;background-image:none!important;color:#fff!important}',
      beat([
        ' .np-card--gold.np-active .np-badge .np-v2-only',
        ' .np-card--gold.np-active .np-badge__save',
        ' .np-card--dark.np-active .np-badge .np-v2-only',
        ' .np-card--dark.np-active .np-badge__save',
        ' .np-card--dark.np-active .np-badge-popular'
      ]) + '{background:transparent!important;background-image:none!important;color:#fff!important}',

      beat(' .np-card--one.np-active') +
        '{background:#1E1E22!important;background-image:none!important;border:2px solid ' + RING + '!important;color:#F4F4F5!important}',
      beat([
        ' .np-card--one.np-active .np-card-title',
        ' .np-card--one.np-active .np-price-onetime',
        ' .np-card--one.np-active [data-onetime-display]'
      ]) + '{color:#F4F4F5!important}',
      beat(' .np-card--one.np-active .np-benefits li') +
        '{color:#D0CBC1!important;font-size:13px!important;font-weight:700!important}',

      beat(' .np-ab-plus') +
        '{display:none;flex-direction:column;gap:5px;margin:11px 0 0}',
      beat(' .np-card--dark:not(.np-active) .np-ab-plus') + '{display:flex}',
      beat(' .np-ab-plus span') + '{font-size:13.5px;font-weight:700;color:#F4F4F5;line-height:1.2}',

      beat(' .np-card.np-active .np-card-body') +
        '{display:block!important;margin:0!important;padding:0!important}',
      beat(' .np-card:not(.np-active) .np-card-body') + '{display:none!important}',
      beat(' .np-card.np-active .np-card-body-inner') +
        '{display:flex!important;flex-direction:column!important;gap:13px!important;margin:15px 0 0!important;padding:15px 0 0!important;border-top:1px solid rgba(22,22,22,.28)!important}',
      beat(' .np-card--dark.np-active .np-card-body-inner') +
        '{margin-top:0!important;padding-top:0!important;border-top:none!important;gap:11px!important}',
      beat(' .np-card--one.np-active .np-card-body-inner') + '{border-top-color:#2F2F2E!important}',
      beat(' .np-card.np-active .np-card-body-inner::before') + '{display:none!important}',
      beat(' .np-benefits') +
        '{display:flex!important;flex-direction:column!important;gap:11px!important;margin:0!important;padding:0!important}',
      beat(' .np-benefits li') +
        '{display:flex!important;align-items:center!important;gap:11px!important;margin:0!important;font-family:Geist,sans-serif!important;font-size:13px!important;font-weight:700!important;line-height:1.2!important}',
      beat([' .np-i-check', ' .np-card--dark.np-active .np-i-check']) +
        '{width:18px!important;height:18px!important;flex:none;overflow:visible;border:0!important;outline:0!important;box-shadow:none!important;background:transparent!important}',
      beat([' .np-card--gold.np-active .np-i-check circle', ' .np-card--dark.np-active .np-i-check circle']) +
        '{fill:#161616!important}',
      beat([' .np-card--gold.np-active .np-i-check path[fill]', ' .np-card--dark.np-active .np-i-check path[fill]']) +
        '{fill:none!important}',
      beat([' .np-card--gold.np-active .np-i-check path', ' .np-card--dark.np-active .np-i-check path']) +
        '{stroke:#fff!important;fill:none!important}',
      beat(' .np-i-x') + '{width:15px!important;height:15px!important;stroke:#ED4C56!important;flex:none}',

      beat(' .np-card--dark.np-active .np-bloodwork-note') +
        '{display:flex!important;align-items:flex-start!important;gap:9px!important;order:0;margin:12px 0 0!important;padding:11px 14px 15px 0!important;background:transparent!important;border:0!important;border-radius:0!important;font-size:10.5px!important;font-weight:700!important;line-height:1.35!important}',
      beat(' .np-card--dark.np-active .np-v2-bloodwork-copy') +
        '{color:#161616!important;font-size:10.5px!important;font-weight:700!important;line-height:1.35!important;white-space:nowrap}',
      beat([' .np-bloodwork-note__icon', ' .np-bloodwork-note > svg']) + '{display:none!important}',
      beat(' .np-ab-info') +
        '{flex:none!important;box-sizing:content-box!important;width:15px!important;height:15px!important;min-width:15px!important;min-height:15px!important;padding:0!important;margin:1px 0 0!important;border:0!important;border-radius:50%!important;background:#161616!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;overflow:hidden}',
      beat(' .np-ab-info svg') +
        '{width:8px!important;height:8px!important;min-width:8px!important;min-height:8px!important;max-width:8px!important;max-height:8px!important;display:block!important;flex:none!important;fill:none!important;stroke:#fff!important}',
      beat(' .np-ab-info svg *') + '{vector-effect:none!important}',
      beat(' .np-card--dark.np-active .np-free-travel-support') +
        '{order:1;display:flex!important;align-items:center!important;gap:10px!important;padding:27px 4px 12px!important;margin:0!important;border-top:1px solid rgba(22,22,22,.28)!important}',
      beat(' .np-card--dark.np-active .np-benefits') + '{order:2}',
      beat(' .np-v2-gift-img') + '{width:48px!important;height:70px!important;object-fit:contain;flex:none}',
      beat(' .np-v2-gift-mark') +
        '{display:flex!important;align-items:center;justify-content:center;box-sizing:border-box;width:56px!important;height:68px!important;flex:none;border:1.5px dashed #161616;border-radius:10px;background:rgba(22,22,22,.06);font-family:Geist,system-ui,sans-serif;font-size:30px;font-weight:500;line-height:1;color:#161616}',
      beat(' .np-v2-gift-copy') + '{font-size:13px!important;font-weight:800!important;line-height:1.22!important;margin:0}',
      beat(' .np-v2-gift-sub') + '{display:block;font-size:10.5px!important;font-weight:500!important;line-height:1.3!important;margin-top:4px}',

      beat(' .np-ab-footer') +
        '{display:flex!important;flex-direction:column!important;align-items:stretch;gap:0;margin-top:22px!important;position:relative;z-index:1}',
      beat(' .np-ab-atc') +
        '{box-sizing:border-box;width:100%;cursor:pointer;border:0;border-radius:8px;padding:16px 18px;margin:0;position:relative;z-index:1;overflow:hidden;isolation:isolate;background:' +
        CTA +
        ';display:flex;align-items:center;justify-content:center;font-family:Geist,sans-serif;font-size:16px;font-weight:700;letter-spacing:normal;text-transform:none;color:#161616}',
      // Shine sweep, same as the quick-buy CTA (np-subscription-widget .np-cta::before).
      // z-index MUST be positive (the popup uses 1): the button paints an opaque
      // gradient background and carries isolation:isolate, so a negative z-index
      // pinned the sweep behind that fill inside the button's own stacking
      // context — the animation ran but was never visible. pointer-events:none
      // keeps the sweep from eating clicks now that it sits above the fill.
      beat(' .np-ab-atc::before') +
        '{content:"";position:absolute;inset:0;z-index:1;pointer-events:none;background:linear-gradient(100deg,transparent 30%,rgba(255,255,255,.55) 50%,transparent 70%);transform:translateX(-120%);animation:np-ab-shine 3.2s ease-in-out infinite}',
      '@keyframes np-ab-shine{0%{transform:translateX(-120%)}45%{transform:translateX(120%)}100%{transform:translateX(120%)}}',
      beat(' .np-ab-atc:hover') + '{filter:brightness(1.1)}',
      beat(' .np-ab-atc:disabled') + '{opacity:.7;cursor:wait;filter:none}',
      beat(' .np-ab-footer .money-back') +
        '{display:flex!important;align-items:center;justify-content:center;gap:7px;width:100%!important;margin:15px 0 0!important;padding:0!important;position:static!important;top:auto!important;transform:none!important;background:none!important}',
      beat([
        ' .np-ab-footer .money-back',
        ' .np-ab-footer .money-back p',
        ' .np-ab-footer .money-back a'
      ]) + '{color:#fff!important;font-size:12.5px!important;font-weight:700!important;letter-spacing:-.01em;text-decoration:none}',
      beat(' .np-card .money-back') + '{display:none!important}'
    ].join('\n');
  }

  function injectFonts() {
    if (document.getElementById('np-ab-idea6-fonts')) return;
    var link = document.createElement('link');
    link.id = 'np-ab-idea6-fonts';
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Archivo:wdth,wght@100,700;100,800;125,600;125,700;125,800&family=Geist:wght@400;500;600;700;800&family=Geist+Mono:wght@400;500;600;700&display=swap';
    (document.head || document.documentElement).appendChild(link);
  }

  function injectCss() {
    injectFonts();
    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      (document.head || document.documentElement).appendChild(style);
    }
    style.setAttribute('data-np-ab-ver', VER);
    style.textContent = cssText();
  }

  function textOf(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function plusify(raw) {
    var t = (raw || '').replace(/^\+\s*/, '').trim();
    if (!t) return '';
    t = t.replace(/\b\w+/g, function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    });
    return '+ ' + t;
  }

  function giftPlusLine(dark) {
    var copy = dark.querySelector('.np-v2-gift-copy');
    var line = '';
    if (copy) {
      var first = '';
      for (var i = 0; i < copy.childNodes.length; i++) {
        var n = copy.childNodes[i];
        if (n.nodeType === 3) {
          first += n.textContent;
        } else if (n.nodeType === 1 && n.tagName === 'BR') {
          break;
        } else if (n.nodeType === 1) {
          first += n.textContent;
          break;
        }
      }
      line = (first || copy.textContent || '').split('(')[0];
    }
    if (!line) {
      var img = dark.querySelector('.np-v2-gift-img');
      if (img && img.alt) line = 'Free ' + img.alt;
    }
    line = plusify(line);
    if (!line) warn('missing gift copy for 90-day plus-line');
    return line;
  }

  function shippingPlusLine(dark) {
    var items = dark.querySelectorAll('.np-benefits li');
    for (var i = 0; i < items.length; i++) {
      var t = textOf(items[i]);
      if (/free shipping forever/i.test(t)) return plusify(t);
    }
    warn('missing "free shipping forever" benefit for 90-day plus-line');
    return '';
  }

  function copyGoldChecksToDark(widget) {
    var goldCheck = widget.querySelector('.np-card--gold .np-i-check');
    var dark = widget.querySelector('.np-card--dark');
    if (!goldCheck || !dark) return;
    if (dark.getAttribute('data-np-ab-checks') === '1') return;
    var darkChecks = dark.querySelectorAll('.np-i-check');
    Array.prototype.forEach.call(darkChecks, function (svg) {
      svg.parentNode.replaceChild(goldCheck.cloneNode(true), svg);
    });
    dark.setAttribute('data-np-ab-checks', '1');
  }

  function swapBloodworkIcon(dark) {
    var note = dark && dark.querySelector('.np-bloodwork-note');
    if (!note || note.querySelector('.np-ab-info')) return;
    var icon = document.createElement('span');
    icon.className = 'np-ab-info';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="11" x2="12" y2="16"></line><circle cx="12" cy="7.5" r="0.5" fill="#FFFFFF"></circle></svg>';
    var old = note.querySelector('.np-bloodwork-note__icon');
    if (old) old.parentNode.replaceChild(icon, old);
    else note.insertBefore(icon, note.firstChild);
  }

  function ensurePlusLines(dark) {
    // Desired order inside .np-card-head (matches Intelligems winner):
    // radio/title → badge → price → plus-lines → delivery
    // np-pdp-buy-box-v2.js moves delivery into the head after prices. If we
    // run first and leave .np-ab-plus as a card-level sibling, v2's
    // `.np-card-head { order: 1 }` pushes the head below the plus (order 0).
    var wrap = dark.querySelector('.np-ab-plus');
    if (!wrap) {
      var ship = shippingPlusLine(dark);
      var gift = giftPlusLine(dark);
      if (!ship && !gift) return;
      wrap = document.createElement('div');
      wrap.className = 'np-ab-plus';
      wrap.setAttribute('aria-hidden', 'true');
      [ship, gift].forEach(function (line) {
        if (!line) return;
        var span = document.createElement('span');
        span.textContent = line;
        wrap.appendChild(span);
      });
    }

    var head = dark.querySelector('.np-card-head');
    var prices = head && head.querySelector('.np-card-prices, .np-price-onetime-wrap');
    var delivery = dark.querySelector('.np-v2-delivery');

    // Mirror v2 layout so plus can sit immediately before delivery
    if (delivery && prices && delivery.parentElement !== head) {
      prices.insertAdjacentElement('afterend', delivery);
    }

    if (delivery && delivery.parentNode) {
      if (wrap.nextSibling !== delivery) {
        delivery.parentNode.insertBefore(wrap, delivery);
      }
    } else if (prices) {
      if (wrap.previousSibling !== prices) {
        prices.insertAdjacentElement('afterend', wrap);
      }
    } else if (head) {
      head.appendChild(wrap);
    } else {
      dark.appendChild(wrap);
    }
  }

  function flagMissingPrices(widget) {
    var cards = widget.querySelectorAll('.np-card');
    if (!cards.length) warn('no .np-card nodes found');
    Array.prototype.forEach.call(cards, function (card) {
      var now = card.querySelector('[data-card-price], [data-onetime-display], .np-price-onetime');
      if (!textOf(now)) warn('missing live price on card', card.className);
      if (card.dataset.purchase === 'subscription' && !card.getAttribute('data-plan-id')) {
        warn('missing data-plan-id on subscription card', card.className);
      }
      if (!card.querySelector('[data-np-add-to-cart]')) {
        warn('missing [data-np-add-to-cart] on card', card.className);
      }
    });
  }

  function moveGuarantee(widget, footer) {
    var mb = widget.querySelector('.money-back');
    if (!mb) {
      warn('missing .money-back guarantee node');
      return;
    }
    footer.appendChild(mb);
  }

  function bindSharedAtc(widget, btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var active = widget.querySelector('.np-card.np-active') || widget.querySelector('.np-card');
      var orig = active && active.querySelector('[data-np-add-to-cart]');
      if (!orig) {
        warn('shared ATC: no original [data-np-add-to-cart] on active card');
        return;
      }
      orig.click();
    });

    function sync() {
      var active = widget.querySelector('.np-card.np-active');
      var orig = active && active.querySelector('[data-np-add-to-cart]');
      if (!orig) return;
      btn.disabled = !!orig.disabled;
      var label = orig.querySelector('.np-cta-text');
      var next = textOf(label) || textOf(orig) || 'Add To Cart';
      if (/add(ing)?/i.test(next) || /cart/i.test(next)) btn.textContent = next;
    }

    var mo = new MutationObserver(sync);
    Array.prototype.forEach.call(widget.querySelectorAll('[data-np-add-to-cart]'), function (orig) {
      mo.observe(orig, { attributes: true, childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('np:selection-change', sync);
    sync();
  }

  function apply(widget) {
    if (widget.getAttribute('data-np-ab-idea6') === '1') return;

    injectCss();
    widget.classList.add('np-ab-idea6');
    widget.setAttribute('data-np-ab-idea6', '1');
    document.documentElement.classList.add('np-ab-idea6');

    flagMissingPrices(widget);

    var dark = widget.querySelector('.np-card--dark');
    if (dark) {
      ensurePlusLines(dark);
      copyGoldChecksToDark(widget);
      swapBloodworkIcon(dark);
    } else warn('missing .np-card--dark (90-day) card');

    var cardsWrap = widget.querySelector('.np-cards');
    var footer = widget.querySelector('.np-ab-footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'np-ab-footer';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'np-ab-atc';
      btn.textContent = 'Add To Cart';
      footer.appendChild(btn);
      if (cardsWrap && cardsWrap.parentNode) {
        cardsWrap.parentNode.insertBefore(footer, cardsWrap.nextSibling);
      } else {
        widget.appendChild(footer);
      }
      moveGuarantee(widget, footer);
      bindSharedAtc(widget, btn);
    }

    window[FLAG].applied = true;
    window[FLAG].widget = widget;
    window[FLAG].version = VER;
  }

  function boot() {
    if (!inScopePage()) return false;
    var widget = findWidget();
    if (!widget) return false;
    apply(widget);
    return true;
  }

  function start() {
    if (!inScopePage()) return;
    if (RERUN) {
      injectCss();
      window[FLAG].version = VER;
      var w = window[FLAG].widget || findWidget();
      if (w) {
        var darkRerun = w.querySelector('.np-card--dark');
        if (darkRerun) ensurePlusLines(darkRerun);
        copyGoldChecksToDark(w);
        swapBloodworkIcon(darkRerun);
      }
      return;
    }
    if (boot()) return;

    var started = Date.now();
    var observer = new MutationObserver(function () {
      if (boot() || Date.now() - started > WAIT_MS) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
      if (!window[FLAG].applied) warn('widget not found on Idea6 PDP within timeout');
    }, WAIT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();